import {Grid, Stack, Typography} from '@mui/material'
import FormTextField from 'src/components/ui/TextField'
import AutoComplete, {AutocompleteOption} from 'src/components/ui/AutoComplete'
import {useFormContext} from 'react-hook-form'
import Checkbox from 'src/components/ui/Checkbox'

interface AssociationDetailsProps {
  cities: any[]
}

const AssociationDetails = ({cities}: AssociationDetailsProps) => {
  const {setValue} = useFormContext()

  const onChangeCityName = (newValue: AutocompleteOption | null) => {
    setValue('association.city', newValue?.label)
  }

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">פרטי עמותה:</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormTextField name="association.name" label="שם עמותה" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="association.associationId" label="מס’ עמותה" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="association.phone" label="טל' עמותה" />
        </Grid>
        <Grid item xs={5}>
          <FormTextField name="association.street" label="רח’" />
        </Grid>
        <Grid item xs={1}>
          <FormTextField name="association.houseNumber" label="מס’ בית" />
        </Grid>
        <Grid item xs={3}>
          <AutoComplete
            options={cities}
            name="association.city"
            label={'עיר'}
            onChange={onChangeCityName}
            getValue={o => o?.label}
          />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="association.zipCode" label="מיקוד" />
        </Grid>
        <Grid item xs={6}>
          <Checkbox name="isAssociationBelongTo" label="העמותה שייכת למוסד" />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default AssociationDetails
